var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 106,
    viewBox: "0 0 93 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.202 0.276223C48.3028 0.156562 49.8485 1.37721 51.5901 2.37919L88.867 23.8395C90.8764 24.998 92.5786 25.9534 92.9153 28.5265C93.0411 29.4869 92.9897 30.4974 92.9891 31.468L92.9897 73.9551C92.9904 74.8833 93.0298 76.3127 92.9472 77.2097C92.8502 78.2391 92.4534 79.2172 91.8064 80.0243C91.0779 80.9325 90.2262 81.3707 89.2343 81.9425C76.5672 89.2437 63.8937 96.534 51.2227 103.829C49.677 104.718 48.6488 105.518 46.8403 105.729C44.5712 105.799 42.9173 104.498 41.0252 103.404L4.28014 82.2502C2.19004 81.0468 0.31133 80.0206 0.062763 77.2934C-0.0396175 76.1698 0.0138262 74.9975 0.0148274 73.8658L0.0145142 31.4407C0.0154529 28.7742 -0.107704 26.3533 2.54249 24.7592C5.19812 23.1618 7.91496 21.6445 10.6021 20.0987L41.9357 2.05772C43.478 1.17041 44.3878 0.428718 46.202 0.276223Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.202 0.276223C48.3028 0.156562 49.8485 1.37721 51.5901 2.37919L88.867 23.8395C90.8764 24.998 92.5786 25.9534 92.9153 28.5265C93.0411 29.4869 92.9897 30.4974 92.9891 31.468L92.9897 73.9551C92.9904 74.8833 93.0298 76.3127 92.9472 77.2097C92.8502 78.2391 92.4534 79.2172 91.8064 80.0243C91.0779 80.9325 90.2262 81.3707 89.2343 81.9425C76.5672 89.2437 63.8937 96.534 51.2227 103.829C49.677 104.718 48.6488 105.518 46.8403 105.729C44.5712 105.799 42.9173 104.498 41.0252 103.404L4.28014 82.2502C2.19004 81.0468 0.31133 80.0206 0.062763 77.2934C-0.0396175 76.1698 0.0138262 74.9975 0.0148274 73.8658L0.0145142 31.4407C0.0154529 28.7742 -0.107704 26.3533 2.54249 24.7592C5.19812 23.1618 7.91496 21.6445 10.6021 20.0987L41.9357 2.05772C43.478 1.17041 44.3878 0.428718 46.202 0.276223Z",
    fill: "url(#paint0_linear_114_74)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0498 79.6827C41.0498 82.5318 44.6486 83.7764 46.4088 81.5362L71.1866 50.0008C72.7332 48.0324 71.3309 45.1473 68.8276 45.1473L44.0498 45.1473C42.393 45.1473 41.0498 46.4905 41.0498 48.1473L41.0498 79.6827Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0498 79.6827C41.0498 82.5318 44.6486 83.7764 46.4088 81.5362L71.1866 50.0008C72.7332 48.0324 71.3309 45.1473 68.8276 45.1473L44.0498 45.1473C42.393 45.1473 41.0498 46.4905 41.0498 48.1473L41.0498 79.6827Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.572 24.3525C52.572 21.539 49.0477 20.2732 47.2576 22.4437L21.0084 54.2709C19.3946 56.2276 20.7865 59.1797 23.3228 59.1797L49.572 59.1797C51.2288 59.1797 52.572 57.8365 52.572 56.1797L52.572 24.3525Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_114_74",
    x1: 14.3499,
    y1: 118.519,
    x2: 64.8067,
    y2: 21.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#001954"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0157D1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo_icon.26e7778f85d1701b504f6fc786ffa8eb.svg";
export { ForwardRef as ReactComponent };